module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Media-library2-bcc94dc764bacc14ff4c9b0a7ef5b68a.svg";